import {
    boolean,
    defaulted,
    literal,
    number,
    object,
    optional,
    union,
} from "superstruct";

import { REVIEWER_NAME_DISPLAY_FORMAT } from "../constants";
import ReviewsSortingOptionsSchema from "./ReviewsSortingOptionsSchema";

const ReviewsStorefrontValuesSettingsSchema = object({
    canUseTranslation: boolean(),
    isProductReviewsWidgetEnabled: boolean(),
    isReviewTitleEnabled: boolean(),
    isReviewTitleRequired: boolean(),
    customerDisplayNamePolicy: defaulted(
        union([
            literal(REVIEWER_NAME_DISPLAY_FORMAT.FULL_NAME),
            literal(REVIEWER_NAME_DISPLAY_FORMAT.SHORTEN_FULL_NAME),
            literal(REVIEWER_NAME_DISPLAY_FORMAT.SHORTEN_LAST_NAME),
            literal(REVIEWER_NAME_DISPLAY_FORMAT.ANONYMOUS),
            literal(REVIEWER_NAME_DISPLAY_FORMAT.CUSTOMER_CHOICE),
        ]),
        REVIEWER_NAME_DISPLAY_FORMAT.FULL_NAME
    ), // TODO remove default after migration
    isReviewsVotingEnabled: boolean(),
    isReviewsPinningEnabled: boolean(),
    isReviewsTranslationEnabled: boolean(),
    isReviewsIncentivizedLabelEnabled: defaulted(boolean(), false),
    defaultSortingOption: ReviewsSortingOptionsSchema,
    isReviewsMediaEnabled: defaulted(boolean(), true),
    reviewsPageWidgetPerPage: optional(number()),
    isReviewEditingEnabled: defaulted(boolean(), false),

    // Hidden settings
    isUniteReviewsOriginProductEnabled: defaulted(boolean(), false), // TODO: remove after migration
});

export default ReviewsStorefrontValuesSettingsSchema;
